import { clsx } from "clsx";
import {
  ArrowRight,
  Calendar,
  ChevronRight,
  ChevronLeft,
  Instagram,
  Facebook,
  ExternalLink,
  Menu,
  X,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";

const icons = {
  arrowRight: ArrowRight,
  calendar: Calendar,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  externalLink: ExternalLink,
  menu: Menu,
  close: X,
  instagram: Instagram,
  facebook: Facebook,
  phone: Phone,
  mail: Mail,
  pin: MapPin,
};

const sizes = {
  base: "w-5 h-5",
  small: "w-4 h-4",
  large: "w-6 h-6",
};

export default function Icon({
  name,
  size = "base",
  color = "text-current",
  className = "",
}) {
  const IconComponent = icons[name];
  if (!IconComponent) return null;

  return <IconComponent className={clsx(sizes[size], color, className)} />;
}
